import { useState } from "react";
import { newSeasonAnime, newSeasonTabs } from "@/mocks/anime";

export default function NewSeasonSection() {
  const [activeTab, setActiveTab] = useState("all");

  const list =
    activeTab === "all"
      ? newSeasonAnime
      : newSeasonAnime.filter((item) => item.category === activeTab);

  return (
    <section id="new" className="w-full bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-secondary-600">
            <i className="ri-calendar-check-line" />
            本季新番推荐
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            正在更新的新番，这一季值得关注的 6 部
          </h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            新番按季度放送、每周更新。下面这几部是近期话题度较高的作品，按题材切换即可快速筛选出你想看的方向。
          </p>
        </div>

        <div
          className="mt-6 flex flex-wrap gap-1.5 p-1 rounded-full bg-background-50 border border-background-200 w-fit max-w-full"
          role="tablist"
          aria-label="新番题材筛选"
        >
          {newSeasonTabs.map((tab) => {
            const active = tab.id === activeTab;
            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={() => setActiveTab(tab.id)}
                className={`px-3 md:px-4 py-1.5 rounded-full text-xs md:text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  active
                    ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop>
          {list.map((item) => (
            <article
              key={item.title}
              className="flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200"
            >
              <div className="w-full h-48 md:h-52 bg-background-200">
                <img
                  src={item.poster}
                  alt={`${item.title} 新番海报`}
                  title={`${item.title} 新番推荐`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <span className="shrink-0 px-2 py-0.5 rounded-full text-[11px] bg-accent-100 text-accent-900">
                    {item.genreLabel}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">{item.schedule}</p>
                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.summary}
                </p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-md text-[11px] bg-background-100 text-foreground-600 border border-background-200"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-8 text-sm text-foreground-500 text-center py-8">
            该题材下暂未收录本季新番，试试切换到「全部新番」。
          </p>
        )}
      </div>
    </section>
  );
}